module.exports = __webpack_public_path__ + "montserrat-light-webfont.70df5da69722ec23336c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.ttf
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-light-webfont.ttf
// module chunks = 11